import script from "./vLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./vLoading.vue?vue&type=script&setup=true&lang=js"

import "./vLoading.vue?vue&type=style&index=0&id=46452eac&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46452eac"]])

export default __exports__